import {
    ChangeDetectionStrategy,
    Component,
    Input,
    SimpleChanges,
    Output,
    EventEmitter,
    OnChanges,
    numberAttribute,
    booleanAttribute
} from '@angular/core';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { UntilDestroy } from '@ngneat/until-destroy';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { GRID_MATERIAL_PROVIDERS } from 'src/app/shared/grid/grid-material-control-defaults.const';

@UntilDestroy()
@Component({
    selector: 'grid-text-filter',
    templateUrl: './grid-text-filter.component.html',
    providers: [...GRID_MATERIAL_PROVIDERS, { provide: FilterBase, useExisting: GridTextFilterComponent }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    viewProviders: [provideNgxMask()],
    imports: [MatFormFieldModule, NgxMaskDirective, MatInputModule, FormsModule]
})
export class GridTextFilterComponent extends FilterBase implements OnChanges {
    @Input() title: string;
    @Input() type: string;
    @Input({ transform: numberAttribute }) maxLength: number = Number.MAX_SAFE_INTEGER;
    @Input() mask = '';
    @Input({ transform: booleanAttribute }) allowZero = false;
    @Output() filterValueChanged = new EventEmitter<CompositeFilterDescriptor>();
    @Output() onEnterPressed = new EventEmitter<any>();

    initValue: string;
    value: string;

    onKeyPress($event: KeyboardEvent) {
        if ($event.keyCode === 13) {
            if (this.value !== this.initValue) {
                this.applyFilter();
            }
            this.onEnterPressed.emit($event);
        }
    }

    onFocusIn() {
        this.initValue = this.getLatestFilterValue();
    }

    onFocusOut() {
        if (isEmpty(this.value) && isEmpty(this.initValue)) {
            return;
        }

        if (this.value?.toString() !== this.initValue?.toString()) {
            this.applyFilter();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.value = this.getLatestFilterValue();
        }
    }

    applyFilter() {
        this.trimFilterByField(this.filter, this.field);
        const filterByValue = !this.value && !this.allowZero ? '' : this.value;

        this.updateFilter({
            field: this.field,
            operator: 'eq',
            value: filterByValue?.toString()
        });
        this.initValue = this.value;

        this.filterValueChanged.emit(this.filter);
    }
}
